<template>
  <div class="Affiche">  
    <div class="Affiche__test">
      <img :src="require('@/commons/img/affiche.png')"/>
    </div>  
  </div>
</template>

<script>


export default {
  name: 'Affiche',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Affiche
    position absolute
    width 100vw
    height 100%
    color white
    background #81849f
    display flex 
    align-items center
    justify-content center

    &__test 
      max-width 480px

</style>